import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { loginUser } from './AuthSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const Auth = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { isLoading } = useAppSelector((state) => state.auth);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            toast.error("Please enter both email and password");
            return;
        }

        try {
            // Dispatch the loginUser thunk and unwrap the result to handle success/failure
            await dispatch(loginUser({ email, password })).unwrap();

            toast.success('Login successful');
            navigate('/home');
        } catch (error: any) {
            console.error('Login failed:', error);
            // The error message is already extracted in the rejected action payload found in 'error'
            toast.error(error || 'Login failed');
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen w-full bg-background">
            {/* Left Side - Image & Testimonial */}
            {/* <div className="hidden  lg:flex w-1/2 relative bg-gray-900 overflow-hidden">
                <iframe className='w-full h-full' src="https://www.youtube.com/embed/fXGn1j3qrmQ?si=bOx4M80bFW0rW8Yh" title="YouTube video player" allow="accelerometer; autoplay; "  ></iframe>

            </div> */}

            {/* Right Side - Login Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-background">
                <div className="w-full max-w-md space-y-8">

                    {/* Header */}
                    <div className="text-center lg:text-left">
                        <h1 className="text-3xl font-bold tracking-tight text-foreground mb-2">
                            Sign in to your account
                        </h1>
                        <p className="text-muted-foreground">
                            Greetings on your return! We kindly request you to enter your details.
                        </p>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleLogin} className="space-y-6">
                        <div className="space-y-2">
                            <label htmlFor="email" className="text-sm font-medium text-foreground">
                                Email
                            </label>
                            <input
                                id="email"
                                type="email"
                                placeholder="pat@saturn.dev"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border border-input bg-background focus:ring-2 focus:ring-ring focus:border-transparent outline-none transition-all placeholder:text-muted-foreground text-foreground"
                                required
                                disabled={isLoading}
                            />
                        </div>

                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <label htmlFor="password" className="text-sm font-medium text-foreground">
                                    Password
                                </label>

                            </div>
                            <div className="relative">
                                <input
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full px-4 py-3 rounded-lg border border-input bg-background focus:ring-2 focus:ring-ring focus:border-transparent outline-none transition-all placeholder:text-muted-foreground text-foreground"
                                    required
                                    disabled={isLoading}
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                                    disabled={isLoading}
                                >
                                    {showPassword ? (
                                        <Eye className="h-5 w-5" />
                                    ) : (
                                        <EyeOff className="h-5 w-5" />
                                    )}
                                </button>
                            </div>
                        </div>



                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-3.5 rounded-xl transition-colors shadow-lg shadow-primary/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                        >
                            {isLoading ? (
                                <div className="h-5 w-5 border-2 border-white/20 border-t-white rounded-full animate-spin" />
                            ) : (
                                'Login'
                            )}
                        </button>


                    </form>
                </div>
            </div>
        </div>
    );
};

export default Auth;
